import { Home, Search, User, Mail, Info } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';
import MobileAccountDialog from './MobileAccountDialog';

export default function MobileBottomNav() {
  const location = useLocation();
  const [showAccountDialog, setShowAccountDialog] = useState(false);

  const navItems = [
    { name: 'Home', icon: Home, path: '/', type: 'link' },
    { name: 'Services', icon: Search, path: '/services', type: 'link' },
    { name: 'About', icon: Info, path: '/about', type: 'link' },
    { name: 'Contact', icon: Mail, path: '/contact', type: 'link' },
    { name: 'Account', icon: User, path: '/account', type: 'button' },
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    if (path === '/account') {
      return location.pathname.startsWith('/account');
    }
    return location.pathname.startsWith(path);
  };

  const handleClick = (item: typeof navItems[0], e: React.MouseEvent) => {
    if (item.type === 'button' && item.name === 'Account') {
      e.preventDefault();
      setShowAccountDialog(true);
    }
  };

  return (
    <>
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        <div className="flex justify-around items-center h-16 px-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            
            const content = (
              <>
                {active && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute top-0 left-0 right-0 h-1 bg-primary-600 rounded-b-full"
                    initial={false}
                    transition={{ type: "spring", stiffness: 380, damping: 28 }}
                  />
                )}
                
                <div className={`relative ${active ? 'text-primary-600' : 'text-gray-500'}`}>
                  <Icon className={`h-5 w-5 ${active ? 'scale-110' : ''} transition-transform duration-200`} />
                </div>
                
                <span className={`text-[10px] mt-1 font-medium ${active ? 'text-primary-600' : 'text-gray-500'}`}>
                  {item.name}
                </span>
              </>
            );

            return item.type === 'button' ? (
              <button
                key={item.name}
                onClick={(e) => handleClick(item, e)}
                className="relative flex flex-col items-center justify-center flex-1 h-full"
              >
                {content}
              </button>
            ) : (
              <Link
                key={item.name}
                to={item.path}
                className="relative flex flex-col items-center justify-center flex-1 h-full"
              >
                {content}
              </Link>
            );
          })}
        </div>
        
        {/* Safe area for iOS */}
        <div className="h-[env(safe-area-inset-bottom)] bg-white"></div>
      </nav>

      {/* Mobile Account Dialog */}
      <MobileAccountDialog 
        isOpen={showAccountDialog} 
        onClose={() => setShowAccountDialog(false)} 
      />
    </>
  );
}
